import { STORE_CURRENCY } from "../constants/wordpress";

export function stripHtml(html = "") {
  if (!html) return "";
  return html
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function formatPrice(price, currency = STORE_CURRENCY) {
  if (price === null || price === undefined || price === "") return null;
  const amount = Number.parseFloat(price);
  if (Number.isNaN(amount)) return null;

  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
    }).format(amount);
  } catch {
    return `${price} ${currency}`;
  }
}

export function getDisplayCategories(categories = []) {
  return categories.filter(
    (category) => category.slug !== "uncategorized" && category.name,
  );
}

export function mapWooProduct(raw) {
  if (!raw) return null;

  const image = raw.images?.[0]?.src || null;
  const gallery = (raw.images || []).map((img) => img.src).filter(Boolean);
  const categories = (raw.categories || []).map((cat) => ({
    id: cat.id,
    name: cat.name,
    slug: cat.slug,
  }));

  const price = raw.price || raw.sale_price || raw.regular_price || "";
  const inStock = raw.stock_status !== "outofstock";

  return {
    id: raw.id,
    slug: raw.slug,
    name: raw.name,
    shortDescription: stripHtml(raw.short_description),
    description: raw.description || "",
    price,
    regularPrice: raw.regular_price,
    salePrice: raw.sale_price,
    onSale: Boolean(raw.on_sale),
    formattedPrice: formatPrice(price),
    formattedRegularPrice: formatPrice(raw.regular_price),
    formattedSalePrice: formatPrice(raw.sale_price),
    currency: STORE_CURRENCY,
    image,
    gallery,
    categories,
    sku: raw.sku || "",
    permalink: raw.permalink,
    purchasable: raw.purchasable !== false,
    inStock,
    stockStatus: raw.stock_status || "instock",
    relatedIds: raw.related_ids || [],
  };
}

export function mapWooCategory(raw) {
  if (!raw) return null;
  return {
    id: raw.id,
    name: raw.name,
    slug: raw.slug,
    count: raw.count,
  };
}
